module.exports = __webpack_public_path__ + "img/2-(2).52092c27.jpg";